/* Graph of Life brand v1.0.0 · tokens.json */
import React from 'react';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/crimson-pro/300.css';
import '@fontsource/crimson-pro/400.css';
import '@fontsource/crimson-pro/500.css';
import '@fontsource/crimson-pro/400-italic.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Home from '@/pages/Home';
import Thesis from '@/pages/Thesis';
import BlueCapital from '@/pages/BlueCapital';
import KnowledgeSystems from '@/pages/KnowledgeSystems';
import Philosophy from '@/pages/Philosophy';
import Methodology from '@/pages/Methodology';
import Systems from '@/pages/Systems';
import About from '@/pages/About';
import Scope from '@/pages/Scope';
import Films from '@/pages/Films';
import Waters from '@/pages/Waters';
import { RouteMetadata } from '@/components/layout/RouteMetadata';
import { ScrollManager } from '@/components/layout/ScrollManager';
import PrimaryNav from '@/components/layout/PrimaryNav';
import SiteFooter from '@/components/layout/SiteFooter';
import { WalkthroughProvider } from '@/components/gol/WalkthroughContext';
import '@/App.css';
import '@/brand/editorial-variables.css';
import '@/brand/graph-of-life.css';
import '@/brand/refinement.css';
import '@/brand/editorial.css';
import '@/brand/immersive-films.css';

function App() {
  return (
    <div className="App min-h-screen bg-surface-base">
      <BrowserRouter>
        <MotionConfig reducedMotion="user">
          <a href="#main" className="gol-skip-link" data-testid="skip-to-content">
            Skip to main content
          </a>
          <WalkthroughProvider>
            <PrimaryNav />
            <ScrollManager />
            <RouteMetadata />
            <main id="main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/films" element={<Films />} />
                <Route path="/films/the-waters-we-share" element={<Waters />} />
                <Route path="/overview" element={<Navigate to="/" replace />} />
                <Route path="/philosophy" element={<Philosophy />} />
                <Route path="/thesis" element={<Thesis />} />
                <Route path="/worldview" element={<Navigate to="/thesis" replace />} />
                <Route path="/methodology" element={<Methodology />} />
                <Route path="/method" element={<Navigate to="/methodology" replace />} />
                <Route path="/systems" element={<Systems />} />
                <Route path="/proof" element={<Navigate to="/systems" replace />} />
                <Route path="/blue-capital" element={<BlueCapital />} />
                <Route path="/knowledge" element={<KnowledgeSystems />} />
                <Route path="/about" element={<About />} />
                <Route path="/scope" element={<Scope />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <SiteFooter />
          </WalkthroughProvider>
        </MotionConfig>
      </BrowserRouter>
    </div>
  );
}

export default App;
